import type {
  AdminListTransferTicketsParams,
  AdminCloseTicketInput,
} from '../api'
import { api } from '../api'

const adminListTransferTickets = async (
  params: AdminListTransferTicketsParams,
) => {
  return await api.v1.adminListTransferTickets(params)
}

const adminCloseTransferTicket = async (data: AdminCloseTicketInput) => {
  return await api.v1.adminCloseTransferTicket(data)
}

export default {
  adminListTransferTickets,
  adminCloseTransferTicket,
}
